import React from 'react';
import "../style/Footer.scss";
const Footer = () => {
    return (
        <footer className="footer">
            
        </footer>
    );
}

export default Footer;
